<template>
  <path pid="0" d="M21.84 3l-12 2A1 1 0 009 6v11H6a3 3 0 000 6h2a3 3 0 003-3V6.85l10-1.67V15h-3a3 3 0 000 6h2a3 3 0 003-3V4a1 1 0 00-1.16-1zM9 20a1 1 0 01-1 1H6a1 1 0 010-2h3zm12-2a1 1 0 01-1 1h-2a1 1 0 010-2h3z"/>
</template>
